//#region src/redux/i18n/initial-state.ts
var initialState = {
	country: void 0,
	locale: void 0,
	isPending: false,
	isRejected: false,
	errorMessage: ""
};
//#endregion
export { initialState };

//# sourceMappingURL=initial-state.js.map